import React,{useEffect} from 'react';
import './Homepage.css';
import AOS from 'aos';

const HomepageFifthSection = () => {
   useEffect(()=>{
      AOS.init();
      window.scroll();
   },[]);
  return (
    <div className='container-fluid' id='homepage-fifth-section'>
        
     <div className="back-design-circle">
        &nbsp;
     </div>
     
     <div className="row top-heading-row" data-aos="fade-up" data-aos-offset="300"  data-aos-duration="1000">
        <h1>Our Prestigious Clients</h1>
        <p>Unique Technologies redefines your relationship with energy. Save money. Minimize your carbon footprint. Take control of your power costs today!</p>
     </div>
     
     <div className=" row clients-row" data-aos="fade-up" data-aos-offset="300"  data-aos-duration="1000">
        <div className="col col-6 client-1">&nbsp;</div>
        <div className="col col-6 client-2">&nbsp;</div>
        <div className="col col-6 client-3">&nbsp;</div>
        <div className="col col-6 client-4">&nbsp;</div>
        <div className="col col-6 client-5">&nbsp;</div>
        <div className="col col-6 client-6">&nbsp;</div>
        <div className="col col-6 client-7">&nbsp;</div>
        {/* <div className="col col-6 client-8">&nbsp;</div> */}
        <div className="col col-6 client-9">&nbsp;</div>
        {/* <div className="col col-6 client-10">&nbsp;</div> */}
        <div className="col col-6 client-11">&nbsp;</div>
        <div className="col col-6 client-12">&nbsp;</div>
        {/* <div className="col col-6 client-13">&nbsp;</div> */}
        <div className="col col-6 client-14">&nbsp;</div>
        {/* <div className="col col-6 client-15">&nbsp;</div> */}
        <div className="col col-6 client-16">&nbsp;</div>
        <div className="col col-6 client-17">&nbsp;</div>
        <div className="col col-6 client-18">&nbsp;</div>
        <div className="col col-6 client-19">&nbsp;</div>
        <div className="col col-6 client-20">&nbsp;</div>
        <div className="col col-6 client-21">&nbsp;</div>
        <div className="col col-6 client-22">&nbsp;</div>
        <div className="col col-6 client-23">&nbsp;</div>
        <div className="col col-6 client-24">&nbsp;</div>
        <div className="col col-6 client-25">&nbsp;</div>
        <div className="col col-6 client-26">&nbsp;</div>
        {/* <div className="col col-6 client-27">&nbsp;</div> */}
        <div className="col col-6 client-28">&nbsp;</div>
        <div className="col col-6 client-29">&nbsp;</div>
        <div className="col col-6 client-30">&nbsp;</div>
        <div className="col col-6 client-31">&nbsp;</div>
        <div className="col col-6 client-32">&nbsp;</div>
     </div>
    </div>
  )
}

export default HomepageFifthSection
